import { render, staticRenderFns } from "./purchaseSplitList.vue?vue&type=template&id=316da39f&scoped=true"
import script from "./purchaseSplitList.vue?vue&type=script&lang=js"
export * from "./purchaseSplitList.vue?vue&type=script&lang=js"
import style0 from "./purchaseSplitList.vue?vue&type=style&index=0&id=316da39f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316da39f",
  null
  
)

export default component.exports